import React from 'react'
import { Link } from 'react-router-dom'
import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

const Topcourses = () => {
  //Top Course SLider
  const topcourseslider = {
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,         // optional, hide next/prev buttons
    dots: false,            // optional, show dots under slider
    pauseOnHover: false,   // optional, keep rotating
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1,
          dots: false,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  }

  const sliderDatas = [
    {
      background: "/assets/img/top/bg-1.png",
      right: "/assets/img/top/1.png",
      title: 'Update Program, Regulasi hingga Lowongan Pekerjaan ada disini!',
      subtitle: 'Bergabung dengan Komunitas Kesehatan Terbesar',
      text: 'Pilih sesuai kebutuhanmu: ',
      btn_text: 'Gabung Sekarang',
      btn_link: 'https://linktr.ee/forumjadipraktisi'
    },
    {
      background: "/assets/img/top/bg-2.png",
      right: "/assets/img/top/2.png",
      title: 'Dapatkan Benefit Menarik Menjadi Mentor Expert di Jadipraktisi!',
      subtitle: 'Kamu Praktisi Professional dan Ingin Berbagi Ilmu?',
      text: 'Yuk Join Sekarang: ',
      btn_text: 'Apply Now!',
      btn_link: 'https://mentor.jadipraktisi.com'
    },
    {
      background: "/assets/img/top/bg-3.png",
      right: "/assets/img/top/3.png",
      title: 'Dapatkan Full Akses Digital Product Menarik di Jadipraktisi!',
      subtitle: 'Mau Belajar dari Digital Product yang Bisa diakses Dari Mana Saja?',
      text: 'Cek Selengkapnya: ',
      btn_text: 'Akses Sekarang',
      btn_link: 'https://lynk.id/jadipraktisi'
    }
  ];

  return (
    <>
      {/* top courses */}
      <section id="grup-komunitas" className="top-courses-sec" style={{ background: 'transparent', paddingBottom: '0px' }}>
        {/* <ImageWithBasePath
          className="top-courses-bg"
          src="./assets/img/bg/bg-20.png"
          alt="img"
        /> */}
        <div className="container">
          <Slider {...topcourseslider} className="top-courses-slider lazy">
            {sliderDatas.map((value, index) => (
              <div>
                <div
                  className="card border-0 text-white"
                  key={index}
                  style={{
                    backgroundImage: `url("${value.background}")`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    // minHeight: "300px",
                    borderRadius: "16px"
                  }}
                >
                  <div className="card-body p-0 h-100">
                    <div className="d-flex align-items-center h-100">

                      {/* LEFT SIDE TEXT */}
                      <div className="col-md-6 col-12 py-5 pe-4 pe-md-0 ps-5" style={{ zIndex: '111' }}>
                        <p className="mb-1 text-white fw-medium text-start">{value.subtitle}</p>
                        <h3 className="fw-bold mb-2 text-white text-start">{value.title}</h3>

                        <div className="d-flex flex-md-row flex-column align-items-start justify-content-start">
                          <p className="my-4 text-white text-start">{value.text}</p>

                          <Link
                            to={value.btn_link}
                            className="btn btn-yellow my-0 my-md-3 ms-0 ms-md-3"
                          >
                            <span className="fw-bold" style={{ color: '#1E344C', fontSize: '18px' }}>
                              {value.btn_text}
                            </span>
                          </Link>
                        </div>
                      </div>

                      {/* RIGHT IMAGE */}
                      <img
                        src={value.right}
                        className='d-none d-md-block text-end'
                        alt=""
                        style={{
                          height: "100%",
                          width: "auto",
                          objectFit: "contain",
                          position: 'absolute',
                          right: '0px'
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </Slider>
        </div>
      </section>
      {/* /top courses */}
    </>
  )
}

export default Topcourses